// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * An allowed endpoint URI + verb combination for external access.
 */
export class ExternalEndpoint implements flatbuffers.IUnpackableObject<ExternalEndpointT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ExternalEndpoint {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsExternalEndpoint(
    bb: flatbuffers.ByteBuffer,
    obj?: ExternalEndpoint,
  ): ExternalEndpoint {
    return (obj || new ExternalEndpoint()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsExternalEndpoint(
    bb: flatbuffers.ByteBuffer,
    obj?: ExternalEndpoint,
  ): ExternalEndpoint {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ExternalEndpoint()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  uri(): string | null;
  uri(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  uri(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * HTTP methods allowed (e.g. `["GET", "POST"]`).
   */
  verbs(index: number): string;
  verbs(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  verbs(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  verbsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  active(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startExternalEndpoint(builder: flatbuffers.Builder) {
    builder.startObject(7);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addUri(builder: flatbuffers.Builder, uriOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, uriOffset, 0);
  }

  static addVerbs(builder: flatbuffers.Builder, verbsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, verbsOffset, 0);
  }

  static createVerbsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startVerbsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addActive(builder: flatbuffers.Builder, active: boolean) {
    builder.addFieldInt8(3, +active, +true);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, deletedAtOffset, 0);
  }

  static endExternalEndpoint(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createExternalEndpoint(
    builder: flatbuffers.Builder,
    idOffset: flatbuffers.Offset,
    uriOffset: flatbuffers.Offset,
    verbsOffset: flatbuffers.Offset,
    active: boolean,
    createdAtOffset: flatbuffers.Offset,
    updatedAtOffset: flatbuffers.Offset,
    deletedAtOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    ExternalEndpoint.startExternalEndpoint(builder);
    ExternalEndpoint.addId(builder, idOffset);
    ExternalEndpoint.addUri(builder, uriOffset);
    ExternalEndpoint.addVerbs(builder, verbsOffset);
    ExternalEndpoint.addActive(builder, active);
    ExternalEndpoint.addCreatedAt(builder, createdAtOffset);
    ExternalEndpoint.addUpdatedAt(builder, updatedAtOffset);
    ExternalEndpoint.addDeletedAt(builder, deletedAtOffset);
    return ExternalEndpoint.endExternalEndpoint(builder);
  }

  unpack(): ExternalEndpointT {
    return new ExternalEndpointT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.uri(),
      this.bb!.createScalarList<string>(this.verbs.bind(this), this.verbsLength()),
      this.active(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
    );
  }

  unpackTo(_o: ExternalEndpointT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.uri = this.uri();
    _o.verbs = this.bb!.createScalarList<string>(this.verbs.bind(this), this.verbsLength());
    _o.active = this.active();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
  }

  unpackFields(...fields: string[]): ExternalEndpointT {
    const t = new ExternalEndpointT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("uri")) {
      t.uri = this.uri();
    }
    if (fieldSet.has("verbs")) {
      t.verbs = this.bb!.createScalarList<string>(this.verbs.bind(this), this.verbsLength());
    }
    if (fieldSet.has("active")) {
      t.active = this.active();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    return t;
  }
}

export class ExternalEndpointT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public uri: string | Uint8Array | null = null,
    public verbs: string[] = [],
    public active: boolean = true,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const uri = this.uri !== null ? builder.createString(this.uri!) : 0;
    const verbs = ExternalEndpoint.createVerbsVector(
      builder,
      builder.createObjectOffsetList(this.verbs),
    );
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;

    return ExternalEndpoint.createExternalEndpoint(
      builder,
      id,
      uri,
      verbs,
      this.active,
      createdAt,
      updatedAt,
      deletedAt,
    );
  }

  clone(): ExternalEndpointT {
    const obj = new ExternalEndpointT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.uri = this.uri;
    obj.verbs = [...this.verbs];
    obj.active = this.active;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    return obj;
  }

  equals(other: ExternalEndpointT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.uri !== other.uri) return false;
    if (this.verbs.length !== other.verbs.length) return false;
    for (let i = 0; i < this.verbs.length; i++) {
      if (this.verbs[i] !== other.verbs[i]) return false;
    }
    if (this.active !== other.active) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    return true;
  }
}

export function verifyExternalEndpoint(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        const len = verifier.checkVector(pos, 4);
        if (len > 0) {
          const vecStart = pos + verifier.readInt32(pos);
          const dataStart = vecStart + 4;
          for (let i = 0; i < len; i++) {
            const strPos = dataStart + i * 4;
            verifier.checkString(strPos);
          }
        }
      }
    }
    verifier.checkScalarField(tablePos, 10, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
